import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';

import DraggableCategoryShift from './DraggableCategoryShift';

export default function UnassignedScheduleCategory({
  shifts = [],
  category,
  onMoveRow,
  onShiftSelect,
}) {
  const hasShifts = shifts.length > 0;
  const titleRef = useRef(null);
  const [{ isOver }, drop] = useDrop({
    accept: 'schedule',
    canDrop: (item) => !hasShifts && item?.shiftCategoryId !== category.id,
    collect: (monitor) => ({
      isOver: monitor.isOver() && monitor.canDrop(),
    }),
    drop: (item) => {
      onMoveRow({
        oldCategoryId: item.shiftCategoryId,
        newCategoryId: category.id,
        oldId: item.id,
        newId: null,
      });
    },
  }, [hasShifts, category.id, onMoveRow]);
  drop(titleRef);

  const swatchColor = category.color || '#FFFFFF';
  const isWhiteSwatch = /^#(?:f{3}|f{6}|f{8})$/i.test(swatchColor.trim());
  return (
    <div className={hasShifts ? 'schedule-category-has-shifts' : undefined}>
      <div
        ref={titleRef}
        className={`schedule-category-title-container${hasShifts ? '' : ' schedule-category-title-container-empty'}${isOver ? ' is-drop-over' : ''}`}
      >
        <div className={`schedule-category-swatch${isWhiteSwatch ? ' schedule-category-swatch-border' : ''}`}>
          <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
            <rect width="100%" height="100%" x="0" y="0" fill={swatchColor} />
          </svg>
        </div>
        <div>{category.name}</div>
        <div style={{ flexGrow: 1 }} />
        <div style={{ paddingRight: 10 }}>
          {shifts.length}
        </div>
      </div>
      {hasShifts && (
        <div className="schedule-category-shift-container">
          {shifts
            .map((shift, index) => (
              <DraggableCategoryShift
                key={shift.id}
                shift={shift}
                index={index}
                category={category}
                onMoveRow={onMoveRow}
                isDraggable
                onShiftSelect={onShiftSelect}
              />
            ))}
        </div>
      )}
    </div>
  );
}

UnassignedScheduleCategory.propTypes = {
  shifts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  })),
  category: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    color: PropTypes.string,
  }).isRequired,
  onMoveRow: PropTypes.func.isRequired,
  onShiftSelect: PropTypes.func.isRequired,
};

UnassignedScheduleCategory.defaultProps = {
  shifts: [],
};
